export const reduxKey = '@@Mention';
